import React from "react";
import styled from "styled-components";
import { Line } from "react-chartjs-2";
import { Icon } from "@blueprintjs/core";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ChartOptions,
  ChartData,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const CardContainer = styled.div`
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.1));
  width: 100%;
`;

const Header = styled.div`
  display: flex;
  margin-bottom: 15px;
`;

// const TitleText = styled.span`
//   font-size: 16px;
//   font-weight: 600;
//   color: #333;
// `;

// const SubTitle = styled.div`
//   font-size: 14px;
//   color: #4caf50; // Adjust color as needed
//   margin-top: 10px;
// `;

// const Amount = styled.span`
//   font-weight: bold;
//   color: #333;
// `;

type SocialChartProps = {
  data: number[];
  labels: string[];
};

const SocialChart = ({
  data,
  labels
}: SocialChartProps) => {
  const chartData: ChartData<"line"> = {
    labels,
    datasets: [
      {
        label: "Social",
        data,
        borderColor: "#6a0dad",
        backgroundColor: "rgba(138, 43, 226, 0.2)",
        borderDashOffset:20,
        fill: true,
        tension: 0.4,
      },
    ],
  };

  const chartOptions: ChartOptions<"line"> = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => `${value}`,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.raw}`,
        },
      },
    },
  };

  return (
    <CardContainer>
      <Header>
        <img src="/icons/socials/web.svg" className="mr-sm" width={30}/>
        <img src="/icons/socials/twitter.svg" className="mr-sm" width={30}/>
        <img src="/icons/socials/linkedin.svg" width={30}/>
      </Header>
      <div >
        <Line data={chartData} options={chartOptions} />
      </div>
      {/* <SubTitle>
        {stage} <Amount>{funding}</Amount>
      </SubTitle> */}
    </CardContainer>
  );
};

export default SocialChart;
